<template>
  <div class="container d-flex flex-column min-vh-100 mb-0">
    <div class="row justify-content-center flex-grow-1 align-items-center">
      <div class="col-11 col-md-8 col-lg-6 col-xl-5 mx-auto">
        <div class="card mt-0">
          <div class="card-header p-0 overflow-hidden">
            <div class="header-container d-flex justify-content-center align-items-center py-3 logo-header">
              <img src="/img/tolsporA5.png" alt="Tólspor Logo" class="logo-image" />
            </div>
          </div>
          <div v-if="loading" class="card-body text-center py-5">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
          </div>
          <div v-else-if="notFound" class="card-body text-center py-5">
            <i class="material-icons" style="font-size: 48px; color: #ccc;">search_off</i>
            <h5 class="mt-3 text-muted">Tool not found</h5>
          </div>
          <div v-else class="card-body">
            <div class="text-center mb-3">
              <img
                v-if="tool.toolImageBytes"
                class="tool-image"
                :src="'data:image/png;base64,' + tool.toolImageBytes"
                alt="Tool image"
              />
            </div>
            <h4 class="text-center mb-1">#{{ tool.customerToolId }} {{ tool.name }}</h4>
            <p v-if="tool.customerName" class="text-center text-muted mb-4">{{ tool.customerName }}</p>
            <hr />
            <div class="contact-info">
              <div v-if="tool.contactEmail" class="d-flex align-items-center mb-3">
                <i class="material-icons me-3 text-primary">email</i>
                <div>
                  <small class="text-muted d-block">Email</small>
                  <a :href="'mailto:' + tool.contactEmail" class="contact-link">{{ tool.contactEmail }}</a>
                </div>
              </div>
              <div v-if="tool.contactPhone" class="d-flex align-items-center mb-3">
                <i class="material-icons me-3 text-primary">phone</i>
                <div>
                  <small class="text-muted d-block">Phone</small>
                  <a :href="'tel:' + tool.contactPhone" class="contact-link">{{ tool.contactPhone }}</a>
                </div>
              </div>
              <div v-if="!tool.contactEmail && !tool.contactPhone" class="text-center text-muted">
                <p>No contact information available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from "@/config";
import { mapMutations } from "vuex";

const body = document.getElementsByTagName("body")[0];

export default {
  data() {
    return {
      tool: {},
      loading: true,
      notFound: false,
    };
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  created() {
    this.fetchPublicTool();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async fetchPublicTool() {
      const toolId = this.$route.params.toolId;
      try {
        const response = await axios.get(`${config.apiUrl}/Public/Tool/${toolId}`);
        this.tool = response.data;
      } catch (error) {
        console.error('Error fetching public tool:', error); // eslint-disable-line no-console
        this.notFound = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.logo-header {
  background-color: #344767;
  border-radius: 0.5rem 0.5rem 0 0;
}
.logo-image {
  max-width: 200px;
  height: auto;
}
.tool-image {
  max-height: 250px;
  max-width: 100%;
  border-radius: 8px;
}
.contact-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}
.contact-link:hover {
  text-decoration: underline;
}
.contact-info {
  padding: 0 1rem;
}
</style>
